import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionStatusPartialCorrectAiIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8682_192)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.99996 0C8.30103 0 8.55044 0.233577 8.57017 0.533987C8.89786 5.5245 8.89786 10.4754 8.57017 15.4659C8.55044 15.7664 8.30102 15.9999 7.99996 15.9999C5.51766 15.9999 3.49766 15.3 2.09879 13.9011C0.699918 12.5023 -1.08571e-07 10.4823 0 7.99997C1.08457e-07 5.51765 0.699919 3.49766 2.09879 2.09879C3.49766 0.699919 5.51766 0 7.99996 0ZM13.6605 3.06265C13.3932 3.3528 12.9413 3.37135 12.6512 3.10407C11.9936 2.49832 11.1945 2.05523 10.3167 1.77685C9.94065 1.6576 9.73249 1.25609 9.85174 0.880063C9.97098 0.50403 10.3725 0.295864 10.7485 0.415113C11.8037 0.749733 12.7916 1.29113 13.6191 2.05335C13.9092 2.32062 13.9277 2.7725 13.6605 3.06265ZM16.0001 8.00038C16.0001 7.47811 15.9618 6.97275 15.8865 6.48665C15.8261 6.09681 15.4612 5.82974 15.0713 5.89011C14.6815 5.95049 14.4144 6.31546 14.4748 6.70531C14.5384 7.11574 14.5715 7.54787 14.5715 8.00038C14.5715 8.45289 14.5384 8.88503 14.4748 9.29545C14.4144 9.68529 14.6815 10.0503 15.0713 10.1107C15.4612 10.171 15.8261 9.90394 15.8865 9.5141C15.9618 9.028 16.0001 8.52265 16.0001 8.00038ZM13.6197 13.9544C13.9096 13.6867 13.9275 13.2349 13.6599 12.945C13.3922 12.6553 12.9403 12.6373 12.6505 12.9049C11.993 13.5121 11.194 13.9512 10.3185 14.2263C9.94217 14.3445 9.73292 14.7455 9.85115 15.1218C9.96939 15.4982 10.3703 15.7074 10.7467 15.5891C11.7988 15.2586 12.7893 14.7214 13.6197 13.9544Z",
			fill: "#633BEE"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8682_192",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "white"
		})
	}) })]
});
export default SvgQuestionStatusPartialCorrectAiIcon;
